var underscoreMin = {exports: {}};

export { underscoreMin as u };
